import React from 'react';

interface PaginationBarProps {
  currentPage: number;
  pageSize: number;
  currentCount: number;
  total?: number;
  hasNextPage?: boolean;
  isLoading?: boolean;
  onPrevious: () => void;
  onNext: () => void;
}

export const PaginationBar: React.FC<PaginationBarProps> = ({
  currentPage,
  pageSize,
  currentCount,
  total,
  hasNextPage,
  isLoading,
  onPrevious,
  onNext,
}) => {
  const startItem = (currentPage - 1) * pageSize + 1;
  const endItem = startItem + currentCount - 1;

  return (
    <div className="bg-white px-4 py-3 border-t border-gray-200 sm:px-6">
      <div className="flex items-center justify-between">
        <div className="text-sm text-gray-700">
          {(() => {
            if (!total && currentCount === 0 && !isLoading) {
              return 'No results found';
            }
            if (currentCount === 0) {
              return 'Loading...';
            }
            return `Viewing ${startItem}-${endItem} of ${total ?? '—'} total`;
          })()}
        </div>
        <div className="flex items-center space-x-2">
          <button
            type="button"
            onClick={onPrevious}
            disabled={currentPage === 1 || !!isLoading}
            className="px-3 py-1.5 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed">
            Previous
          </button>
          <span className="text-sm text-gray-700">Page {currentPage}</span>
          <button
            type="button"
            onClick={onNext}
            disabled={!hasNextPage || !!isLoading}
            className="px-3 py-1.5 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed">
            {isLoading ? 'Loading…' : 'Next'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default PaginationBar;
